import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import get from 'lodash/get';
import {
    initialiseEventCentreInstance
} from './live-player-helpers';
import {
    isNullOrUndefined,
    hasValue,
    isScriptEmbedded,
    embedScript,
    parametersDidUpdate,
    toggleCssClass
} from '../../../general/js/general-helpers';
import {
    getEventCentreMessageTopics, getIMGArenaESModuleScriptInnerHTML, getLivePlayerRouteToHoleConfig, setClipTagContainerId, shouldLoadRouteToHoleClipTag, updateEventCentreContext
} from '../../shot-tracker/js/shot-tracker-helpers';
import { shotTrackerConstants } from '../../shot-tracker/js/shot-tracker-constants';

class LivePlayerRouteToHole extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            r2hElement: null
        };

        this.clipTagContainerDiv = React.createRef();

        this.loadRouteToHoleClipTag = this.loadRouteToHoleClipTag.bind(this);
        window.frontRowSeatESModuleCallback = this.loadRouteToHoleClipTag;

        this.livePlayerShotViewConfig = null;
        this.clipTagParameters = { };
    }

    componentDidMount() {
        this.init();
    }

    componentDidUpdate() {
        this.init();
    }

    init() {
        this.initRouteHolderDivId();
        this.loadRouteToHoleScript();
        this.checkIfRouteToHoleClipTagLoaded();
    }

    initRouteHolderDivId() {
        const { setClipTagContainer } = this.props;
        const livePlayerShotViewConfig = getLivePlayerRouteToHoleConfig(this.props);

        if (hasValue(livePlayerShotViewConfig)) {
            if (!_.isEqual(this.livePlayerShotViewConfig, livePlayerShotViewConfig)) {
                this.livePlayerShotViewConfig = livePlayerShotViewConfig;

                setClipTagContainerId(this.livePlayerShotViewConfig, this.clipTagContainerDiv.current);
                setClipTagContainer(this.clipTagContainerDiv.current);
            }
        }
    }

    checkIfRouteToHoleClipTagLoaded() {
        const { clipTagParameters } = this.props;
        if (parametersDidUpdate(this.clipTagParameters, clipTagParameters)) {
            this.loadRouteToHoleClipTag();
        }
    }

    loadRouteToHoleScript() {
        if (hasValue(this.livePlayerShotViewConfig)) {
            const { scripts } = this.livePlayerShotViewConfig;

            if (!hasValue(scripts)) {
                return;
            }

            scripts.forEach((script) => {
                const { scriptSourceUrl, scriptType } = script;
                let innerHTML = '';

                if (scriptType === 'module') {
                    innerHTML = getIMGArenaESModuleScriptInnerHTML(scriptSourceUrl);
                }

                if (!isScriptEmbedded(scriptSourceUrl, innerHTML)) {
                    const { loadScriptAsync, useNoModule } = script;

                    embedScript(scriptSourceUrl, loadScriptAsync, this.loadRouteToHoleClipTag, useNoModule, scriptType, innerHTML);
                }
            });
        }
    }

    loadRouteToHoleClipTag() {
        const clipTag = window.frontRowSeat;
        const routeHolder = this.clipTagContainerDiv.current;

        if (hasValue(this.livePlayerShotViewConfig) &&
            shouldLoadRouteToHoleClipTag(routeHolder, clipTag)) {
            this.clipTagParameters = get(this.props, shotTrackerConstants.clipTagParameters, { });
            this.setState(initialiseEventCentreInstance(clipTag, this.clipTagParameters, routeHolder), this.setHole);
        }
    }

    setHole() {
        const { r2hElement } = this.state;
        const { setIsClipTagLoaded } = this.props;

        if (!isNullOrUndefined(r2hElement)) {
            if (hasValue(this.clipTagParameters)) {
                const routeHolder = this.clipTagContainerDiv.current;

                toggleCssClass(routeHolder, 'is-hidden', false);
                this.updateEventCentreContext();
                setIsClipTagLoaded(true);
            }
        }
    }

    updateEventCentreContext() {
        const { r2hElement } = this.state;
        const messageTopics = getEventCentreMessageTopics();
        const data = get(this.clipTagParameters, shotTrackerConstants.initialContext, {});

        if (isNullOrUndefined(r2hElement) || !hasValue(messageTopics) || !hasValue(data)) {
            return;
        }

        updateEventCentreContext(data, messageTopics.CONTEXT_UPDATE, r2hElement);
    }

    render() {
        return (
            <div className="live-player-route-to-hole">
                <div ref={this.clipTagContainerDiv} className="live-player-route-to-hole__iframe is-hidden">

                </div>
            </div>
        );
    }
}

LivePlayerRouteToHole.propTypes = {
    livePlayer: PropTypes.object,
    clipTagParameters: PropTypes.object,
    setIsClipTagLoaded: PropTypes.func,
    setClipTagParameters: PropTypes.func
};

export default LivePlayerRouteToHole;
